// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--vmhPQ","title":"_9330de7794--title--NDQP1","list":"_9330de7794--list--YP3lj","list--odd":"_9330de7794--list--odd--BJ2eA"};